import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import z from "zod";
import { useAuth } from "../../hooks";

const FormSchema = z.object({
  firstname: z.string().min(1, "First Name is required."),
  lastname: z.string().optional(),
  email: z.email("Invalid email address."),
  phone: z.string().min(1, "Phone Number is required."),
});

type FormValues = z.infer<typeof FormSchema>;

const defaultValues: FormValues = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
};

type Props = {
  onBack: () => void;
  onSubmit: (data: any) => void;
};

export const CustomerForm = ({ onBack, onSubmit }: Props) => {
  const { customer } = useAuth();

  const { control, handleSubmit } = useForm<FormValues>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      ...defaultValues,
      firstname: customer.first_name,
      lastname: customer.last_name,
      email: customer.email,
      phone: customer.phone,
    },
  });

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col xs={12} md={6}>
            <Controller
              name="firstname"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    First Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="lastname"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="email"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Email Address <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    {...field}
                    isInvalid={!!fieldState.error}
                  />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <Controller
              name="phone"
              control={control}
              render={({ field, fieldState }) => (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Phone Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control {...field} isInvalid={!!fieldState.error} />
                  <Form.Control.Feedback type="invalid">
                    {fieldState.error?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          </Col>
        </Row>

        <div className="d-flex justify-content-between gap-3 mt-3">
          <Button
            type="button"
            variant="light"
            onClick={onBack}
            className="px-4"
          >
            Back
          </Button>
          <Button type="submit" className="px-4">
            Next
          </Button>
        </div>
      </form>
    </>
  );
};
